import React from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";

import TeacherLogin from "../../pages/LoginPages/TeacherLogin";
import StudentLogin from "../../pages/LoginPages/StudentLogin";
import Login from "../../pages/Login";
import StudentSignUp from "../../pages/LoginPages/StudentSignUp";
import TeacherSignUp from "../../pages/LoginPages/TeacherSignUp";
import EmailVerification from "../../pages/LoginPages/EmailVerification";
import Verification from "../../pages/LoginPages/Verfication";
import Forgetpassword from "../../pages/LoginPages/Forgetpassword";
import AdminLogin from "../../pages/LoginPages/AdminLogin";
import ConfirmPass from "../../pages/LoginPages/ConfirmPass";
import Roles from "../../pages/root/Roles";
import EmailVerificationStatus from "../../pages/root/EmailVerificationStatus";

// `<Navigate to>` takes a literal path, not a route pattern — it can't
// substitute a `:param` placeholder itself, so param-carrying redirects need
// a tiny wrapper that reads the actual matched value and rebuilds the target.
function RedirectWithParam({ to, param }) {
  const params = useParams();
  return <Navigate to={to.replace(`:${param}`, params[param])} replace />;
}

function LoginLayout() {
  return (
    <div>
      <Routes>

        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/status" element={<EmailVerificationStatus />} />
        <Route path="/" element={<Roles Login='login' />} />
        <Route path="/login-page/:type" element={<Login />} />
        <Route path="/mentor-login" element={<TeacherLogin />} />
        <Route path="/mentor-sign-up" element={<TeacherSignUp />} />
        <Route path="/mentee-login" element={<StudentLogin />} />
        <Route path="/mentee-sign-up" element={<StudentSignUp />} />
        <Route path="/email-verification" element={<EmailVerification />} />
        <Route path="/verification" element={<Verification />} />
        <Route path="/forget-pass" element={<Forgetpassword />} />
        <Route path="/confirm-pass/:token" element={<ConfirmPass />} />

        {/* Kebab-case migration redirects — keep old bookmarks/links working */}
        <Route path="/loginPage/:type" element={<RedirectWithParam to="/login-page/:type" param="type" />} />
        <Route path="/mentorLogin" element={<Navigate to="/mentor-login" replace />} />
        <Route path="/mentorSignUp" element={<Navigate to="/mentor-sign-up" replace />} />
        <Route path="/menteeLogin" element={<Navigate to="/mentee-login" replace />} />
        <Route path="/menteeSignUp" element={<Navigate to="/mentee-sign-up" replace />} />
        <Route path="/emailVerification" element={<Navigate to="/email-verification" replace />} />
        <Route path="/forgetPass" element={<Navigate to="/forget-pass" replace />} />
        <Route path="/confirmPass/:token" element={<RedirectWithParam to="/confirm-pass/:token" param="token" />} />
      </Routes>
    </div>
  );
}

export default LoginLayout;
